import FooterLink from "./FooterLink";

function FooterLinkGroup({ data }) {
  return (
    <div className="py-4">
      <p className="font-poppins font-semibold text-gray-400 text-sm pb-3">
        {data.title}
      </p>
      <div>
        {data.links.map((link, index) => (
          <FooterLink key={index} name={link.name} to={link.path} />
        ))}
      </div>
    </div>
  );
}

export default FooterLinkGroup;
